import './App.css';
import '../src/assets/scss/styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MainRoutes } from './router';
import { ToastContainer } from 'react-toastify';
import "./assets/language/i18n";
import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React from 'react';
import Zendesk, { ZendeskAPI } from "./zendesk/ZendeskConfig";
type AppProps = {
  pca: IPublicClientApplication;
};
const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_KEY || "";

function App({ pca }: AppProps) {
  const handleLoaded = () => {
    ZendeskAPI("webWidget", "hide");
    ZendeskAPI("webWidget:launcher", "hide");
    ZendeskAPI("webWidget:chat", "hide");
    ZendeskAPI("webWidget:helpCenter", "hide");
    ZendeskAPI("webWidget:talk", "hide");
    ZendeskAPI("webWidget:answerBot", "hide");
    
    // Listen for chat close events and hide the widget completely
    ZendeskAPI("webWidget", "on", "close", () => {
      ZendeskAPI("webWidget", "hide");
      ZendeskAPI("webWidget:launcher", "hide");
      
    });
    
    // Also hide the chat button/launcher
    ZendeskAPI("webWidget:chat", "hide");
  };

  const openZendesk = () => {
    ZendeskAPI("webWidget", "show");
    ZendeskAPI("webWidget", "open");
  };

  // Make openZendesk available globally
  React.useEffect(() => {
    (window as any).openZendesk = openZendesk;
    return () => {
      delete (window as any).openZendesk;
    };
  }, []);

  return (
    <MsalProvider instance={pca}>
    <div className="App">
       <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme='colored'
        />
    <MainRoutes />
    <Zendesk defer zendeskKey={ZENDESK_KEY} onLoaded={handleLoaded} />
    </div>
    </MsalProvider>
  );
}

export default App;
